import { z } from "zod";

export const EditFeedbackSchema = z.object({
  isChecked: z.boolean(),
});

export type EditFeedbackDto = z.infer<typeof EditFeedbackSchema>;
